import { render, staticRenderFns } from "./EodbReport.vue?vue&type=template&id=b22e5f24&scoped=true&"
import script from "./EodbReport.vue?vue&type=script&lang=js&"
export * from "./EodbReport.vue?vue&type=script&lang=js&"
import style0 from "./EodbReport.vue?vue&type=style&index=0&id=b22e5f24&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b22e5f24",
  null
  
)

export default component.exports